<template>
    <div class="quote rt-h-screen rt-flex rt-justify-center rt-items-center">
        <div class="rt-w-4/5
            sm:rt-w-3/5
        ">
            <div class="rt-flex rt-flex-col sm:rt-flex-row">
                <div class="rt-w-full sm:rt-w-2/5 rt-p-4 rt-bg-white
                    sm:rt-p-8
                ">
                    <img :src="logoUrl" alt="Logo" class="rt-h-16 rt-mx-auto
                        sm:rt-h-auto sm:rt-max-w-full
                    ">
                    <h3 class="rt-mt-4 rt-text-red-800 rt-font-bold rt-text-2xl">YOUR CUSTOM QUOTE INCLUDES:</h3>
                    <ul class="rt-ml-6 rt-mt-4 rt-text-gray-700 rt-text-xl">
                        <li>—<span class="rt-ml-2">{{ sqft }} sqft</span></li>
                        <li>—<span class="rt-ml-2">{{ layers }} Layer of Shingles</span></li>
                        <li>—<span class="rt-ml-2">{{ complexity | capitalize }} </span></li>
                        <li>—<span class="rt-ml-2">{{ material | capitalize }} Material</span></li>
                        <li>—<span class="rt-ml-2">{{ labor | capitalize }} Crew</span></li>
                        <li>—<span class="rt-ml-2">Cost of debris disposal</span></li>
                    </ul>
                    <div class="rt-flex rt-justify-center rt-mb-4">
                        <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="prevStep">BACK</button>
                    </div>
                </div>
                <div class="rt-w-full rt-p-4 col-right rt-flex rt-justify-center rt-items-center
                    sm:rt-w-3/5 sm:rt-p-8
                ">
                    <div class="rt-text-left rt-w-4/5">
                        <h1 class="rt-uppercase rt-text-white rt-font-bold rt-text-md
                            sm:rt-text-2xl
                        ">YOUR APPROXIMATE ROOF COST:</h1>
                        <h3 class="rt-font-bold rt-text-red-700 rt-mt-1 rt-text-3xl rt-whitespace-no-wrap
                            sm:rt-text-5xl sm:rt-mt-2"><sup>$</sup> {{ lowerRange }} - {{ upperRange }}</h3>
                        <button class="rt-h-8 rt-w-full rt-bg-red-700 rt-flex rt-justify-center rt-items-center rt-text-white rt-text-md rt-mt-2
                            sm:mt-8 sm:rt-h-12 sm:rt-text-xl
                        " @click="handleContactUs">Contact Us</button>
                    </div>
                </div>
            </div>
            <div class="rt-h-6 rt-w-full rt-bg-red-600
                sm:rt-h-12
            "></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Constants from '../constants'

export default {
    name: 'Quote',
    filters: {
        capitalize(string) {
            return string.split(' ').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ')
        }
    },
    computed: {
        stepModel: {
            get() {
                return this.step
            },
            set(value) {
                this.setStep(value)
            }
        },
        ...mapState({
            step: state => state.Common.step,
            sqft: state => state.SquareFootage.sqft,
            layers: state => state.ShingleLayers.layers,
            complexity: state => state.Complexity.complexity,
            labor: state => state.Labor.labor,
            material: state => state.Material.material,
            labor: state => state.Labor.labor,
        }),
        materialCostPerSqft() {
            let cost = 0;
            switch(this.material) {
                case 'economic':
                    cost = Constants.materialCostUsdPerSqftBasic
                    break;
                case 'good':
                    cost = Constants.materialCostUsdPerSqftGood
                    break;
                case 'premium':
                    cost = Constants.materialCostUsdPerSqftPremium
                    break;
            }

            return cost
        },
        materialCost() {
            return this.materialCostPerSqft * this.sqft;
        },
        layerComplexityMultiplier() {
            return (this.layers * Constants.layerComplexityMultiplier) - Constants.layerComplexityMultiplier
        },
        roofComplexityMultiplier() {
            let complexity = Constants.roofComplexityMultiplierSimple;
            switch(this.complexity) {
                case 'simple':
                    complexity = Constants.roofComplexityMultiplierSimple;
                    break;
                case 'more-complex':
                    complexity = Constants.roofComplexityMultiplierMoreComplex
                    break;
                case 'complex':
                    complexity = Constants.roofComplexityMultiplierVeryComplex
                    break;
            }

            return complexity
        },
        totalLaborMultiplier() {
            return this.layerComplexityMultiplier + this.roofComplexityMultiplier + 1
        },
        laborCostPerSqft() {
            let cost = 0;
            switch(this.labor) {
                case 'unspecialized':
                    cost = this.totalLaborMultiplier * Constants.laborCostUsdPerSqftSubContracted
                    break;
                case 'factory-certified':
                    cost = this.totalLaborMultiplier * Constants.laborCostUsdPerSqftFactoryCertified
                    break;
            }

            return cost
        },
        laborCost() {
            return this.laborCostPerSqft * this.sqft
        },
        wasteRemovalCost() {
            let total = this.sqft * this.layers
            return total < Constants.wasteRemovalMaxSqftPerDumpster ? Constants.wasteRemovalCostUsdPerDumpster : (Constants.wasteRemovalCostUsdPerDumpster + ((total - Constants.wasteRemovalMaxSqftPerDumpster) * Constants.wasteRemovalCostUsdAdditionalWastePerSqft))
        },
        totalCost() {
            return this.materialCost + this.laborCost + this.wasteRemovalCost
        },
        lowerRange() {
            let lowerRange = (this.totalCost * ( ( 100 - Constants.lowerRangePercent) / 100 ))
            return (Math.round(lowerRange / 100) * 100).toLocaleString()
        },
        upperRange() {
            let upperRange = (this.totalCost * ( ( 100 + Constants.lowerRangePercent) / 100 ))
            return (Math.round(upperRange / 100) * 100).toLocaleString()
        },

        costPerSquareFootLower() {
            return parseFloat(this.upperRange) / this.sqft;
        },

        costPerSquareFootUpper() {
            return parseFloat(this.lowerRange) / this.sqft;
        },
        logoUrl() {
            return `${window.roofingData.pluginUrl}dist/${require('@/assets/images/logo.png')}`
        }
    },
    methods: {
        ...mapMutations("Common", [
            'setStep',
        ]),
        handleContactUs() {
            window.open("https://provenroofing.com/contact-us/","new")
        },
        prevStep() {
            this.stepModel = 'labor';
        },
    }
}
</script>

<style lang="scss" scoped>
    .quote {
        background: linear-gradient(90deg, #2B2B2B 35%, #B61B1C 35%);
    }
    .col-right {
        background: #2B2B2B;
    }
    @media (max-width: 639px) {
        .quote {
            background: linear-gradient(180deg, #2B2B2B 35%, #B61B1C 35%);
        }
    }

</style>
